import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeFullStory } from './lib/utils/fullstory';

// Initialize FullStory (only in production)
initializeFullStory();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);